import * as React from 'react'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/atoms/carousel'
import { cn } from '@/lib/client'
import Autoplay from 'embla-carousel-autoplay'

export function CardCarousel<T>({
  elements,
  id,
  slideContent,
  className,
}: {
  elements: Array<T>
  id: string
  slideContent: (element: T) => React.ReactNode
  className?: string
}) {
  const plugin = React.useRef(Autoplay({ delay: 5000, stopOnMouseEnter: true }))

  return (
    <Carousel
      opts={{
        loop: true,
        align: 'start',
      }}
      className="w-full"
      onMouseEnter={plugin.current.stop}
      onMouseLeave={plugin.current.reset}
      plugins={[plugin.current]}
    >
      <div className="flex gap-4 justify-end pt-4">
        <CarouselPrevious className="relative left-0 top-0" />
        <CarouselNext className="relative left-0 top-0" />
      </div>
      <CarouselContent>
        {elements.map((element) => (
          <CarouselItem
            key={element[id]}
            className={cn('md:basis-1/2 lg:basis-1/3 xl:basis-1/4', className)}
          >
            {slideContent(element)}
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  )
}
